import { IListingFloorplans, IListingPhotos } from '@llws/lift-entity-interfaces';
import app from '@/main';

export const getNewListingFloorplan = (
  clientId: number,
  buildingId: number,
  image: string,
  pdf: string | null,
  imageHeight: number,
  imageWidth: number,
  name: string,
  active: 0 | 1,
  showWebsite?: 0 | 1,
  showRlsListings?: 0 | 1,
): IListingFloorplans => ({
  clientId,
  buildingId,
  image,
  imageHeight,
  imageWidth,
  created: new Date(),
  createdUserId: parseInt(app()?.$rsGlobals.$currentUser.userId || '0', 10),
  active,
  pdf,
  name,
  orderBy: 0,
  showWebsite: showWebsite || 1,
  showRlsListings: showRlsListings || 1,
});
